import { initFacetOverviewFilters } from '~/js/components/facet-overview-filters';

initFacetOverviewFilters( {
	sectionSelector: '.exp-impact-cases-overview',
	filterTargets: [
		'industry',
		'service',
	],
	urlPanelMappings: [
		{ param: '?_connected_impact_stories_industries', target: 'industry' },
		{ param: '?_connected_impact_stories_services', target: 'service' },
	],
	bindMobileSearch: true,
} );
